import React, { PureComponent } from 'react'
import Fieldset from '../Fieldset'
import Label from '../Label'
import FormRow from '../FormRow'
import TextField from '../TextField'
import FieldHelp from '../FieldHelp'

const getYearsFromProps = props => props.value !== '' ? Math.floor(props.value / 12) : ''
const getMonthsFromProps = props => props.value !== '' ? props.value % 12 : ''
const removeNegative = value => Math.abs(parseInt(value, 10))

class FieldMonths extends PureComponent {
  static defaultProps = {
    yearsLabel: 'Años',
    monthsLabel: 'Meses'
  }

  state = {
    years: getYearsFromProps(this.props),
    months: getMonthsFromProps(this.props)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      const years = getYearsFromProps(this.props)
      const months = getMonthsFromProps(this.props)

      if (years !== this.state.year || months !== this.state.months) {
        this.setState({ years, months })
      }
    }
  }

  handleChange() {
    if (this.props.onChange) {
      const months = Math.max(this.state.months + (this.state.years * 12), 0)
      this.props.onChange(months)
    }
  }

  handleYearChange = event => {
    const { value } = event.target
    const years = value !== '' ? parseInt(value, 10) : ''
    this.setState({ years }, this.handleChange)
  }

  avoidNegative = event => {
    // keypad, key minus
    if (event.key === '-') event.preventDefault()
  }

  handleMonthKeyDown = event => {
    this.avoidNegative(event)

    // Arrow up, Arrow down keyCodes
    if (event.keyCode === 38 || event.keyCode === 40) {
      event.preventDefault()
      const months = this.state.months || 0
      const monthSum = event.keyCode === 38 ? 1 : -1
      const newMonths = months + monthSum
      const years = this.state.years || 0

      this.setState({
        months: newMonths > 0 || years > 0 ? newMonths : 0
      }, this.handleChange)
    }
  }

  handleMonthChange = event => {
    const { value } = event.target
    const months = value !== '' ? removeNegative(value) : ''
    const years = months >= 12 ? 0 : this.state.years

    // const months = value ? parseInt(event.target.value, 10) : ''
    this.setState({ months, years }, this.handleChange)
  }

  render() {
    const {
      label,
      name,
      yearsLabel,
      monthsLabel,
      shrinkLabel,
      error,
      onFocus,
      onBlur,
      tip,
      help
    } = this.props
    const { years, months } = this.state

    return (
      <Fieldset>
        <Label as='legend' error={error}>{label}</Label>
        <FormRow>
          <TextField
            type='number'
            name={`${name}-months`}
            value={months}
            label={monthsLabel}
            shrinkLabel={shrinkLabel}
            onChange={this.handleMonthChange}
            onKeyDown={this.handleMonthKeyDown}
            onFocus={onFocus}
            onBlur={onBlur}
            error={error}
          />
          <TextField
            type='number'
            name={`${name}-years`}
            value={years}
            label={yearsLabel}
            shrinkLabel={shrinkLabel}
            onChange={this.handleYearChange}
            onKeyDown={this.avoidNegative}
            onFocus={onFocus}
            onBlur={onBlur}
            error={error}
            min={0}
          />
        </FormRow>
        {tip && <FieldHelp>{tip}</FieldHelp>}
        {help && <FieldHelp error={error}>{help}</FieldHelp>}
      </Fieldset>
    )
  }
}

export default FieldMonths
